import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { PRODUCT_CATEGORIES } from "@/data/products";

export default function Products() {
  return (
    <div>
      <PageHero
        eyebrow="Products"
        title="Industrial products, engineered for productivity."
        description="Nine focused categories covering lubricants, cutting tools, precision tooling, safety, packaging and beyond — all sourced from authorized brands."
        image="https://images.unsplash.com/photo-1727292486169-33eba0865c99?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
      />

      <section className="section bg-white">
        <div className="container-nago">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {PRODUCT_CATEGORIES.map(({ slug, title, short, Icon, image, brands }) => (
              <Link
                to={`/products/${slug}`}
                key={slug}
                className="group card-industrial p-0 overflow-hidden flex flex-col"
                data-testid={`products-card-${slug}`}
              >
                <div className="relative h-52 overflow-hidden bg-white p-4 flex items-center justify-center">
                  <img
                    src={image}
                    alt={title}
                    loading="lazy"
                    className="max-h-full max-w-full object-contain group-hover:scale-105"
                    style={{ transition: "transform 500ms ease" }}
                  />
                  <div className="absolute top-3 left-3 w-11 h-11 bg-[#1E3A8A] text-white flex items-center justify-center rounded-xl shadow-md">
                    <Icon className="w-5 h-5" />
                  </div>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="font-display font-bold text-lg text-slate-900 leading-snug">
                    {title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">
                    {short}
                  </p>
                  {brands?.length ? (
                    <div className="mt-4 flex flex-wrap gap-1.5">
                      {brands.slice(0, 3).map((b) => (
                        <span
                          key={b}
                          className="text-[10px] font-semibold uppercase tracking-wider bg-slate-100 text-slate-700 px-2 py-1 rounded-xl"
                        >
                          {b}
                        </span>
                      ))}
                    </div>
                  ) : null}
                  <div className="mt-5 inline-flex items-center text-sm font-semibold text-[#1E3A8A] group-hover:text-[#E30613]">
                    View details <ArrowRight className="w-4 h-4 ml-1" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABand
        title="Can't find a specific product or grade?"
        subtitle="We supply most standard and application-specific grades, sizes and configurations on request. Send us your requirement and we'll source it."
      />
    </div>
  );
}
